import Button from '@uds/button';
import { useHistory, NavLink, useLocation } from 'react-router-dom';
import { jsx } from 'react/jsx-runtime';
import Link from '@uds/link';
import TextButton from '@uds/text-button';
import { useWindow } from '@uds/hooks';
import { useEffect } from 'react';

function useHandleOnClick(href, isExternalRoute, onClick) {
  const history = useHistory();
  return event => {
    if (onClick) {
      onClick(event);
    }
    if (!isExternalRoute && href != null && !(event.ctrlKey || event.metaKey)) {
      event.preventDefault();
      history.push(href);
    }
  };
}

const ReactRouterButton = _ref => {
  let {
    href,
    isExternalRoute,
    children,
    onClick,
    ...props
  } = _ref;
  const handleOnClick = useHandleOnClick(href, isExternalRoute, onClick);
  return /*#__PURE__*/jsx(Button, {
    href: href,
    ...props,
    onClick: handleOnClick,
    children: children
  });
};
ReactRouterButton.displayName = 'ReactRouterButton';
var ReactRouterButton$1 = ReactRouterButton;

const ReactRouterLink = _ref => {
  let {
    children,
    onClick,
    isNavLink = false,
    isNavLinkExact,
    href,
    isExternalRoute,
    ...props
  } = _ref;
  const handleOnClick = useHandleOnClick(href, isExternalRoute, onClick);
  if (href != null && isNavLink) {
    return /*#__PURE__*/jsx(NavLink, {
      to: href,
      exact: isNavLinkExact,
      ...props,
      onClick: handleOnClick,
      children: children
    });
  }
  return /*#__PURE__*/jsx(Link, {
    href: href,
    ...props,
    onClick: handleOnClick,
    children: children
  });
};
ReactRouterLink.displayName = 'ReactRouterLink';
var ReactRouterLink$1 = ReactRouterLink;

const ReactRouterTextButton = _ref => {
  let {
    href,
    isExternalRoute,
    children,
    onClick,
    ...props
  } = _ref;
  const handleOnClick = useHandleOnClick(href, isExternalRoute, onClick);
  return /*#__PURE__*/jsx(TextButton, {
    href: href,
    ...props,
    onClick: handleOnClick,
    children: children
  });
};
ReactRouterTextButton.displayName = 'ReactRouterTextButton';
var ReactRouterTextButton$1 = ReactRouterTextButton;

function useAutoScroll() {
  const {
    pathname
  } = useLocation();
  const window = useWindow();
  /**
   * We should listen only to pathname cause we can change programmatically hashes and params
   * eg: ?domain= or #customers
   *
   */
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [window, pathname]);
}

export { ReactRouterButton$1 as ReactRouterButton, ReactRouterLink$1 as ReactRouterLink, ReactRouterTextButton$1 as ReactRouterTextButton, useAutoScroll };
